import { apolloClient } from 'lib/withApollo'

import MODEL_QUERY from 'graphql/model.query'
import WORDPRESS_MODEL_QUERY from 'graphql/wordpressModel.query'
import ModelPage from '../../../components/ModelPage'
import uppercaseFirst from '../../../helpers/uppercaseFirst'

function ModelQuery(props) {
  const { title, site, boardType, boardSlug, modelSlug } = props

  return (
    <ModelPage
      {...props}
      url={`/${site}/${boardType}/${boardSlug}/${modelSlug}`}
      title={`${title}${boardType ? ` | ${uppercaseFirst(boardType)}` : ''}`}
    />
  )
}

export default ModelQuery

export async function getStaticProps({ params }) {
  const { site, modelSlug, boardType } = params

  const [{ data, error }, { data: solarnetData, error: solarnetError }] =
    await Promise.all([
      apolloClient()
        .query({
          query: WORDPRESS_MODEL_QUERY,
          context: { site },
          variables: { site, modelUri: modelSlug, boardType },
        })
        .catch((e) => {
          return { data: null, error: e }
        }),
      apolloClient()
        .query({
          query: MODEL_QUERY,
          context: { site: 'solarnet' },
          variables: { modelUri: modelSlug, boardType, site },
        })
        .catch((e) => {
          return { data: null, error: e }
        }),
    ])

  if (error || solarnetError) {
    console.error(`Error loading Model props - ${error}`)
    return { props: {}, notFound: true }
  }

  // The cover image should be the very first image in the gallery and not the model image!!
  const image =
    solarnetData.model?.galleries[0]?.assets[0] ?? solarnetData.model?.image

  const props = {
    ...params,
    ...data.modelBy,
    ...data.modelBy?.acfModel,
    ...solarnetData.model,
    image,
  }

  return {
    props,
    revalidate: 60 * 60,
  }
}

export async function getStaticPaths() {
  const paths = []

  return {
    paths,
    fallback: 'blocking',
  }
}
